import axios from "axios";

function getData(data) {
    return axios.post('api/pensionado/dataPensionado', data);
}

function guardarData(data) {
    return axios.post('api/pensionado/guardarPensionado', data);
}

function eliminarPensionado(data) {
    return axios.delete(`api/pensionado/${data}`);
}

function actualizarData(data) {
    return axios.post('api/pensionado/actualizarPensionado', data);
}

export {
    getData,
    guardarData,
    actualizarData,
    eliminarPensionado
}
